cv.PostDetailsView = Marionette.LayoutView.extend({
  className : 'modal-details',

  template : cv.Templates['post/details'],

  behaviors : [{
    behaviorClass : cv.FormBehavior
  }],

  bindings : {
  },

  events : {
  },

  validation: {
    stub: [{
      required: true,
      msg: "Required"
    },{
      valid_post_stub: true
    }],
    published_at : [],
    status : []
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenToOnce(this.model, 'sync', function(){
      if(moment(this.model.get('published_at')).isValid()){
        this.$('.publish-container').show();
      }else{
        this.$('.publish-container').hide();
      }
    }, this);

    console.log('PostDetailsView initialized');
  },

  templateHelpers: function(){
    return {
      form_datepicker: cv.Templates['global/form/form_datepicker']({
        label : 'Publish Date',
        id : 'published_at',
        default_date : cv.campaign.get('end_date'),
        timezone : 'UTC',
        static : false,
        help_text : 'Specify the publish date in UTC.'
      })
    }
  },

  onAttach: function(){
  },

  onDestroy: function(){
  }
});
